/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: "false" | "true" }} Valve_Fail_To_CloseInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "Th. head fails to close valve body completely" |
* | "true" | "Th. head fails to close valve body completely since {date}" |
*
* @param {Valve_Fail_To_CloseInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_fail_to_close = /** @type {((inputs: Valve_Fail_To_CloseInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Fail_To_CloseInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Th. head fails to close valve body completely`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Th. head fails to close valve body completely since ${i?.date}`);
		return /** @type {LocalizedString} */ ("valve_fail_to_close");
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`La tête th. n'arrive pas à fermer complètement le corps de vanne`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`La tête th. n'arrive pas à fermer complètement le corps de vanne depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ ("valve_fail_to_close");
	}
});